import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";
/* ---------------- GET VALUATOR DETAIL ---------------- */
export const fetchPageNavigation = createAsyncThunk(
	"pageNavigation/fetchPageNavigationDetail",
	async ({ examinationCode, qpCode, bookletCode ,valuationTypeCode}, { rejectWithValue }) => {
		try {
			const response = await api.get(`/v1/BookletPageNavigation/${bookletCode}/${examinationCode}/${qpCode}/${valuationTypeCode}/booklet`);

			return response.data.data;
		} catch (err) {
			return rejectWithValue(err.response?.data);
		}
	},
);

export const createPageNavigation = createAsyncThunk(
  "pageNavigation/createPageNavigation",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(
        "/v1/BookletPageNavigation",
        payload
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);

export const updatePageNavigation = createAsyncThunk(
  "pageNavigation/updatePageNavigation",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.put(
        "/v1/BookletPageNavigation",
        payload
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);

const initialState = {
	data: [],
	pageNavigationId: null,
	loading: false,
	error: null,
};
const pageNavigationSlice = createSlice({
	name: "pageNavigation",
	initialState,
	reducers: {
		clearPageNavigation: () => initialState,
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchPageNavigation.pending, (state) => {
				state.loading = true;
			})
			.addCase(fetchPageNavigation.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload;
			})
			.addCase(fetchPageNavigation.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload;
			})

			 .addCase(createPageNavigation.pending, (state) => {
        state.loading = true;
      })
      .addCase(createPageNavigation.fulfilled, (state, action) => {
        state.loading = false;

        state.pageNavigationId = action.payload.data;
      })
      .addCase(createPageNavigation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
	  
.addCase(updatePageNavigation.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatePageNavigation.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updatePageNavigation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
			
	},
});

export const { clearPageNavigation } = pageNavigationSlice.actions;
export default pageNavigationSlice.reducer;
